export const setToken = async (Token: string) => {
  localStorage.setItem("authToken", Token);
};

export const getToken = async () => {
  const token = localStorage.getItem("authToken");
  return token;
};

const AUTH_STORAGE_KEYS_ON_SESSION_EXPIRED = ["authToken", "isAuthenticated", "pptSocketSession"] as const;
export function clearAuthLocalStorageAndReload(): void {
  for (const key of AUTH_STORAGE_KEYS_ON_SESSION_EXPIRED) {
    localStorage.removeItem(key);
  }
  window.location.reload();
}

export default function writeDataToOfficeDocument(result: Object): void {
  setToken(result["token"]);
  localStorage.setItem("isAuthenticated", "true");
}
